enum IdentityProvider {
    None = 0,
    EmailPassword = 1,
    FirebaseEmailPassword = 2,
    Microsoft = 3,  // Microsoft Entra + Firebase custom token
    Google = 4      // Google + Firebase custom token (future)
}

export default IdentityProvider;
